module.exports = __webpack_public_path__ + "img/survey.1477e570.svg";